import { render, staticRenderFns } from "./Webhooks.vue?vue&type=template&id=c4cf608c&scoped=true&"
import script from "./Webhooks.vue?vue&type=script&lang=js&"
export * from "./Webhooks.vue?vue&type=script&lang=js&"
import style0 from "./Webhooks.vue?vue&type=style&index=0&id=c4cf608c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cf608c",
  null
  
)

export default component.exports